import React from "react";
import { NavHashLink } from "react-router-hash-link";

export function AnchorLink(props) {
    return (
        <div
            className="z-20"
            onClick={props.onClick}
        >
            <NavHashLink
                to={props.target}
                activeStyle={{ color: "#242d29" }}
                className={`flex text-center text-[14px] line-clamp-2 items-center md:px-12 h-full cursor-pointer font-bold no-underline text-white ${
                    props.className ? props.className : ""
                }`}
            >
                {props.content}
            </NavHashLink>
        </div>
    );
}
